import React from 'react';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  BarChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Bar,
} from 'recharts';
import moment from 'moment/moment';

const MasterMeterChart = ({ data }) => {
  const reversed = data.reverse();
  let dataArray = [];
  for (let i = 1; i < data.length; i++) {
    const waterUsed = Math.abs(
      reversed[i].masterReading - reversed[i - 1].masterReading
    );
    const date = moment(reversed[i].timestamp).local().format('M/DD');
    dataArray.push({ date: date, waterUsed: waterUsed });
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={dataArray}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <XAxis dataKey="date" />
        <YAxis allowDeicmals={false} />
        <CartesianGrid strokeDasharray="3 3" />
        <Tooltip />
        <Legend />
        <Bar
          name={'per thousand gallons'}
          dataKey={'waterUsed'}
          fill={'#8DD35F'}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

MasterMeterChart.propTypes = {
  data: PropTypes.array,
};

export default MasterMeterChart;



// WEBPACK FOOTER //
// ./src/components/reading/charts/MasterMeterChart.js